import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pending\"><path d=\"M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5m0 19.219A8.72 8.72 0 0 1 3.281 12 8.72 8.72 0 0 1 12 3.281 8.72 8.72 0 0 1 20.719 12 8.72 8.72 0 0 1 12 20.719\" /><path d=\"m16.095 14.967-3.343-2.416V6.75a.19.19 0 0 0-.187-.187h-1.127a.19.19 0 0 0-.188.187v6.455c0 .06.028.117.077.152l3.877 2.827a.19.19 0 0 0 .262-.04l.67-.914a.187.187 0 0 0-.041-.263\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol